/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_StarterInputs */



/**
* | output |
* | --- |
* | "Starter" |
*
* @param {Signup_Plan_StarterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_starter = /** @type {((inputs?: Signup_Plan_StarterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_StarterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Débutant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anlasser")
	if (locale === "it") return /** @type {LocalizedString} */ ("Antipasto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стартер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Motor de arranque")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("起动机")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スターター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टार्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciante")
	return /** @type {LocalizedString} */ ("Starter")
});